// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 97) return "static/chunks/97-9519e3a53084e1dd.js";
	if (chunkId === 70) return "static/chunks/70-1b3c4a31b3ba2cb1.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"c059e7930fed1452","205":"67e56ec58883c7b0","319":"0cbc2894a3f1b950","340":"995edd5df5724b9e","367":"93d559518db2b251","639":"6f30bd92b2c07e9c","748":"616557f4246d3331"}[chunkId] + ".js";
};